import React from 'react';
import BaseSkeleton from './base-skeleton';
import { useTheme } from '../../context/theme-context';

interface SkeletonCommunityProps {
  variant?: 'user' | 'recommended';
  count?: number;
}

const SkeletonCommunityItem: React.FC<{ variant?: 'user' | 'recommended' }> = ({ variant = 'user' }) => {
  const { isDarkMode } = useTheme();
  
  const bgClass = variant === 'recommended' 
    ? isDarkMode ? 'bg-neutral-800/50' : 'bg-[#1976d21c]'
    : isDarkMode ? 'bg-neutral-800' : 'bg-white';

  return (
    <div className={`border-b ${bgClass} px-5 gap-1 p-[1px] border-[#CED5DC] items-center flex animate-pulse`}>
      <div className="flex-grow flex py-4">
        {/* Community image skeleton */}
        <div className="overflow-hidden flex justify-center">
          <BaseSkeleton variant="rounded" width="60px" height="50px" className="rounded-[50px]" />
        </div>
        
        {/* Community info skeleton */}
        <div className="px-2 w-full">
          <BaseSkeleton variant="text" width="150px" height="20px" className="mb-2" />
          <BaseSkeleton variant="text" width="80px" height="12px" />
        </div>
      </div>
      
      {/* Join button skeleton (only for recommended) */}
      {variant === 'recommended' && (
        <div className="w-auto flex justify-center px-2">
          <BaseSkeleton variant="rounded" width="70px" height="32px" />
        </div>
      )}
    </div>
  );
};

const SkeletonCommunity: React.FC<SkeletonCommunityProps> = ({ variant = 'user', count = 5 }) => {
  
  return (
    <div className="flex flex-col w-full pb-2 mb-12 dark:bg-neutral-800">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCommunityItem key={index} variant={variant} />
      ))}
    </div>
  );
};

export default SkeletonCommunity;